import moment from "moment";

//Expected to be in the format dd mm yyyy
export const changeDateToMomentFormat = (date, splitChar) => {
  const dateArray = date.split(splitChar);
  const day = dateArray && dateArray[0];
  let month = dateArray && dateArray[1];
  const year = dateArray && dateArray[2];
  const res = moment({ year: year, month: --month, day: day });
  return res;
};

export const spliteByWeeks = data => {
  return (
    data &&
    data.reduce((result, ppd) => {
      const asMoment = moment(ppd.dayDate);
      const weekNumber = asMoment.week();
      result[weekNumber] = result[weekNumber] || [];
      result[weekNumber].push(ppd);
      return result;
    }, {})
  );
};



// WEBPACK FOOTER //
// ./src/helpers/dateHelpers.js